/*eslint-env jquery*/
export const getDictionary = (dictionary = {}) => {
  return {
    get(section, tag) {
      return dictionary[`${section}::${tag}`] || "Item not recognized";
    },
  };
};

export const copy = (text = "", cb) => {
  let input = document.createElement("textarea");
  input.textContent = text;
  input.style.position = "fixed";
  document.body.appendChild(input);
  input.select();
  try {
    document.execCommand("copy");
    if (cb) cb(text);
    return;
  } catch (error) {
    return false;
  } finally {
    document.body.removeChild(input);
  }
};

export const notify = (
  title,
  message,
  type = "success",
  position = "bottom right"
) => {
  $.Notification.notify(type, position, title, message);
};

export const testRegex = (value = "", candidate) => {
  return new RegExp(candidate.replace(/\\/g, "\\\\").toLowerCase()).test(
    value.toLocaleLowerCase()
  );
};

export const ready = (fn) => {
  if (
    document.attachEvent
      ? document.readyState === "complete"
      : document.readyState !== "loading"
  ) {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};

export const showFile = (blob, id) => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([blob], { type: "application/pdf" });

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.

  window.URL = window.URL || window.webkitURL;

  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement("a");
  link.href = data;
  link.download = `masar-report-${id}.pdf`;
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
};



// WEBPACK FOOTER //
// ./src/utils/index.js